import { LOCALES } from 'i18n/locales';

export const contactDetailsTabIntl = {
    [LOCALES.ENGLISH]: {
        'contactDetailsTab.contactDetailsHeading': 'Contact details',
        'contactDetailsTab.assetHeading': 'Contact details for this asset',
        'contactDetailsTab.assetOwnerHeading': 'Asset owner',
        'contactDetailsTab.contactDetailsError': 'Contact details could not be loaded.',
        'contactDetailsTab.contactDetailsError.button': 'Retry'
    },
    [LOCALES.WELSH]: {
        'contactDetailsTab.contactDetailsHeading': 'Manylion cyswllt',
        'contactDetailsTab.assetHeading': '[Contact details for this asset]',
        'contactDetailsTab.assetOwnerHeading': 'Perchennog ased',
        'contactDetailsTab.contactDetailsError': '[Contact details could not be loaded.]',
        'contactDetailsTab.contactDetailsError.button': '[Retry]'
    }
};
